import React from 'react';
import { Clock } from 'lucide-react';

const RecentActivity = ({ currentApplication }) => {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
      <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Clock className="h-5 w-5 text-gray-500" />
        Recent Activity
      </h3>
      
      <div className="relative pl-4 border-l-2 border-gray-100 space-y-6 my-2">
        {currentApplication ? (
          <>
            <div className="relative">
              <span className="absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-green-500 ring-4 ring-white shadow-sm"></span>
              <div className="flex flex-col">
                <span className="text-sm font-bold text-gray-900">Application Updated</span>
                <span className="text-xs text-gray-500 mt-1">
                  Your application for <span className="font-medium text-gray-700">"{currentApplication.trademarkName || 'Untitled'}"</span> was saved.
                </span>
                <span className="text-xs text-gray-400 mt-1 font-medium">
                  {new Date(currentApplication.updatedAt || Date.now()).toLocaleDateString()}
                </span>
              </div>
            </div>

            {currentApplication.analysisCompleted && (
              <div className="relative">
                <span className="absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-purple-500 ring-4 ring-white shadow-sm"></span>
                <div className="flex flex-col">
                  <span className="text-sm font-bold text-gray-900">Analysis Completed</span>
                  <span className="text-xs text-gray-500 mt-1">
                    Marko AI finished analyzing your trademark for conflicts.
                  </span>
                </div>
              </div>
            )}

            <div className="relative">
              <span className="absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-blue-500 ring-4 ring-white shadow-sm"></span>
              <div className="flex flex-col">
                <span className="text-sm font-bold text-gray-900">Application Started</span>
                <span className="text-xs text-gray-500 mt-1">
                  You started a new trademark application.
                </span>
                <span className="text-xs text-gray-400 mt-1 font-medium">
                  {new Date(currentApplication.createdAt || Date.now()).toLocaleDateString()}
                </span>
              </div>
            </div>
          </>
        ) : (
          <div className="relative">
            <span className="absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-gray-300 ring-4 ring-white shadow-sm"></span>
            <div className="flex flex-col">
              <span className="text-sm font-bold text-gray-900">Account Created</span>
              <span className="text-xs text-gray-500 mt-1">
                Welcome to Marko! Your journey begins here.
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;
